import { ErrorResponseBody } from '@doda/api-client/aspida/@types';

/**
 * nullable な要素を除去する型ガード関数
 * https://zenn.dev/lollipop_onl/articles/eoz-ts-non-nullable
 * @param value
 * @returns NonNullableな配列
 */
export const nonNullable = <T>(value: T): value is NonNullable<T> =>
  value != null;

/** 配列が存在し、かつ要素が１つのみであるか判定 */
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
export const hasOnlyOneElement = <T extends unknown>(
  arr: T[] | undefined
): arr is [T] => {
  return arr != null && arr.length === 1;
};

/** エラーレスポンス型か判定する */
export const isErrorResponseBody = (
  response: unknown
): response is Required<ErrorResponseBody> =>
  typeof response === 'object' &&
  response !== null &&
  'message' in response &&
  'code' in response &&
  'details' in response;
